import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { StyledAdmin } from "./Admin.styled";
import {
  ChampagneIcon,
  ChartLineIcon,
  ListMagnifyingGlassIcon,
  PlusIcon,
} from "@phosphor-icons/react";
import { useEffect, useState } from "react";
import { ArtTable } from "../../Components/ArtTable/ArtTable";
import { AddArt } from "../../Components/AddArt/AddArt";
import { DarkOverlay } from "../../darkOverlay/DarkOverlay";
import { ArtMenu } from "../../Components/ArtMenu/ArtMenu";
import { useProfile } from "../../stores/useProfile";
import { useNavigate } from "react-router-dom";
import { AddExpo } from "../../Components/AddExpo/AddExpo";

export const AdminPage = () => {
  const [selected, setSelected] = useState<string | null>("list");
  const [darkOverlayOpened, setDarkOverlayOpened] = useState<boolean>(false);
  const [selectedArtitemId, setSelectedArtitemId] = useState<number>(0);
  const { user } = useProfile();
  const navigate = useNavigate();

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newValue: string | null
  ) => {
    if (newValue !== null) {
      setSelected(newValue);
    }
  };

  const handleImageClick = (artItemId: number) => {
    setDarkOverlayOpened(true);
    setSelectedArtitemId(artItemId);
  };

  useEffect(() => {
    const originalStyle = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = "hidden";

    if (!user) navigate("/login")

    return () => {
      document.body.style.overflow = originalStyle;
    };
    // eslint-disable-next-line
  }, [user]);

  return (
    <StyledAdmin>
      <DarkOverlay
        opened={darkOverlayOpened}
        component={<ArtMenu artItemId={selectedArtitemId} />}
        onClose={() => {
          setDarkOverlayOpened(false);
        }}
      />
      <ToggleButtonGroup
        value={selected}
        exclusive
        onChange={handleChange}
        className="pageButtons">
        <ToggleButton value="chart" className="pageButton">
          <ChartLineIcon size={64} />
        </ToggleButton>
        <ToggleButton value="expos" className="pageButton">
          <ChampagneIcon size={64} />
        </ToggleButton>
        <ToggleButton value="list" className="pageButton">
          <ListMagnifyingGlassIcon size={64} />
        </ToggleButton>
        <ToggleButton value="add" className="pageButton">
          <PlusIcon size={64} />
        </ToggleButton>
      </ToggleButtonGroup>

      {selected === "chart" ? (
        <></>
      ) : selected === "list" ? (
        <ArtTable onImageClick={(artItemId) => handleImageClick(artItemId)} />
      ) : selected === "expos" ? (
        <AddExpo />
      ) : (
        <AddArt />
      )}
    </StyledAdmin>
  );
};
